




















































import {Vue, Component, Prop} from 'vue-property-decorator';
import {PopupData, PopupRequestData} from '@/types';

class Data {
  static create(popupRequestData: PopupRequestData): PopupData {
    const hasCloseBtn = popupRequestData.hasCloseBtn === undefined ? true : popupRequestData.hasCloseBtn;
    const closeBtnText = popupRequestData.closeBtnText || '닫기';
    const hasConfirmBtn = popupRequestData.hasConfirmBtn === undefined ? true : popupRequestData.hasConfirmBtn;
    const confirmBtnText = popupRequestData.confirmBtnText || '확인';

    return {
      ...popupRequestData,

      hasCloseBtn,
      hasConfirmBtn,
      confirmBtnText,
      closeBtnText,

      width: popupRequestData.width || 650,
      titleDescription: popupRequestData.titleDescription || '',
      titleDescriptionCss: popupRequestData.titleDescriptionCss || '',
      classStr: popupRequestData.classStr || '',
      title: popupRequestData.title || '레이어 팝업',
      hasHeaderCloseBtn: popupRequestData.hasHeaderCloseBtn ?? true,
      maxHeight: popupRequestData.maxHeight ? popupRequestData.maxHeight : 500,
      verticalScrollType: popupRequestData.hasVerticalScroll ? (popupRequestData.hasVerticalScroll == true ? 'auto' : 'hidden') : 'auto',
      confirmBtnAutoClose: popupRequestData.confirmBtnAutoClose || false,
      closeBtnAutoClose: popupRequestData.closeBtnAutoClose || false,
      zIndexStyle: popupRequestData.zIndex ? `style="z-index:${popupRequestData.zIndex}"` : '',
      noTitle: popupRequestData.noTitle ?? false,
    };
  }
}

@Component
export default class LayerPopup extends Vue {
  @Prop({required: true})
  visible!: boolean; // this is sync data. Avoid mutating a prop directly!
  @Prop({required: true})
  popupRequestData!: PopupRequestData;

  private data: PopupData = Data.create(this.popupRequestData);

  private get hasConfirmCallBack() {
    return this.$listeners && this.$listeners.confirmCallback;
  }

  private get hasCancelCallback() {
    return this.$listeners && this.$listeners.cancelCallback;
  }

  private get hasCloseCallback() {
    return this.$listeners && this.$listeners.closeCallback;
  }

  public mounted() {}

  private confirmCallback() {
    if (!this.hasConfirmCallBack) {
      this.closeLayoutPopup();
    } else {
      this.$emit('confirmCallback');
    }
  }

  private cancelCallback() {
    this.closeLayoutPopup();
    this.$emit('cancelCallback');
  }

  private closeCallback() {
    this.closeLayoutPopup();
    this.$emit('closeCallback');
  }

  private closeLayoutPopup() {
    this.$emit('update:visible', false);
  }
}
